import type { RatingDialogState } from './types';

export const initialRatingDialogState: RatingDialogState = {
  isOpen: false,
  backgroundImage: '',
  title: '',
  rating: null,
  review: null
};
